import type React from 'react'
import {
	createContext,
	type ReactNode,
	useContext,
	useEffect,
	useState,
} from 'react'

export type Contrast = 'regular' | 'high'

interface ContrastContextType {
	contrast: Contrast
	setContrast: (contrast: Contrast) => void
}

const ContrastContext = createContext<ContrastContextType | undefined>(undefined)

export const ContrastProvider: React.FC<{ children: ReactNode }> = ({
	children,
}) => {
	const [contrast, setContrast] = useState<Contrast>(() => {
		const saved = localStorage.getItem('contrast')
		if (saved === 'high' || saved === 'regular') return saved
		return 'regular'
	})

	useEffect(() => {
		localStorage.setItem('contrast', contrast)
		const root = document.documentElement
		if (contrast === 'high') {
			root.classList.add('hc')
		} else {
			root.classList.remove('hc')
		}
	}, [contrast])

	return (
		<ContrastContext.Provider value={{ contrast, setContrast }}>
			{children}
		</ContrastContext.Provider>
	)
}

export const useContrast = () => {
	const context = useContext(ContrastContext)
	if (context === undefined) {
		throw new Error('useContrast must be used within a ContrastProvider')
	}
	return context
}
